import { createInstance } from "@optimizely/react-sdk";

export const optimizelyClient = createInstance({
    sdkKey: process.env.REACT_APP_OPTIMIZELY_KEY,
});
